import { render, staticRenderFns } from "./AIAssistantChatWindow.vue?vue&type=template&id=220bd174&scoped=true&"
import script from "./AIAssistantChatWindow.vue?vue&type=script&lang=js&"
export * from "./AIAssistantChatWindow.vue?vue&type=script&lang=js&"
import style0 from "./AIAssistantChatWindow.vue?vue&type=style&index=0&id=220bd174&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "220bd174",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
import { VSpacer } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBtn,VIcon,VProgressCircular,VSpacer,VTextField})
